module.exports = __webpack_public_path__ + "img/app.6a6f7411.png";